import { EDUCATION_OPPORTUNITIES } from 'constants/education-step.constants';
import { PROOF_OF_EDUCATION, SHARE_CE_UNITS } from 'constants/constants';
import _cloneDeep from 'lodash-es/cloneDeep';

export const defaultWebinarContent = {
  hours: null,
  payment_required: false,
  cost: null,
  name: '',
  description: '',
  date_model: null,
  date: null,
  time: {
    hour: null,
    minute: null,
  },
  link: 'https://',
};

export const defaultCourseContent = {
  hours: null,
  title: '',
};

export const DEFAULT_ACTIVITY_TYPE_NAME = 'continuing education courses';

export enum CONTINUOUS_EDUCATION_UNIT {
  CREDITS = 1,
  POINTS = 2,
  HOURS = 3,
  UNITS = 4,
}

export const defaultContinuousEducationUnit = {
  id: CONTINUOUS_EDUCATION_UNIT.HOURS,
  description: '',
};

export const defaultEducationalContent = {
  ce_type: {},
  format: [],
  course: defaultCourseContent,
  opportunity_id: EDUCATION_OPPORTUNITIES.NO_REQUIREMENTS,
  webinar: defaultWebinarContent,
  advancedOptionsAllowed: false,
  continuousEducationUnit: _cloneDeep(defaultContinuousEducationUnit),
  activityTypes: [],
  shareCeUnits: SHARE_CE_UNITS.NO,
  proofOfEducationRequired: PROOF_OF_EDUCATION.OPTIONAL,
};

export const CONTINUOUS_EDUCATION_UNIT_NAME = {
  [CONTINUOUS_EDUCATION_UNIT.CREDITS]: 'credits',
  [CONTINUOUS_EDUCATION_UNIT.POINTS]: 'points',
  [CONTINUOUS_EDUCATION_UNIT.HOURS]: 'hours',
  [CONTINUOUS_EDUCATION_UNIT.UNITS]: 'units',
};

export const CONTINUOUS_EDUCATION_UNIT_OPTIONS = [
  { id: CONTINUOUS_EDUCATION_UNIT.CREDITS, name: 'Credits' },
  { id: CONTINUOUS_EDUCATION_UNIT.POINTS, name: 'Points' },
  { id: CONTINUOUS_EDUCATION_UNIT.HOURS, name: 'Hours' },
  { id: CONTINUOUS_EDUCATION_UNIT.UNITS, name: 'Units' },
];
